import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedShape: null,
  selectedCaratRange: null,
  selectedCell: null, // { shape, caratRange }
  selectedMetric: 'turn',
  selectedNeedsMetric: 'needs'
};

const shapeCaratSlice = createSlice({
  name: 'shapeCarat',
  initialState,
  reducers: {
    setSelectedShape: (state, action) => {
      state.selectedShape = action.payload;
    },
    setSelectedCaratRange: (state, action) => {
      state.selectedCaratRange = action.payload;
    },
    setSelectedCell: (state, action) => {
      state.selectedCell = action.payload;
    },
    setSelectedMetric: (state, action) => {
      state.selectedMetric = action.payload;
    },
    setSelectedNeedsMetric: (state, action) => {
      state.selectedNeedsMetric = action.payload;
    },
    resetShapeCaratSelection: (state) => {
      return initialState;
    }
  }
});

export const {
  setSelectedShape,
  setSelectedCaratRange,
  setSelectedCell,
  setSelectedMetric,
  setSelectedNeedsMetric,
  resetShapeCaratSelection
} = shapeCaratSlice.actions;

// Selectors
export const selectShapeCaratState = (state) => state.shapeCarat;
export const selectSelectedShape = (state) => state.shapeCarat.selectedShape;
export const selectSelectedCaratRange = (state) => state.shapeCarat.selectedCaratRange;
export const selectSelectedCell = (state) => state.shapeCarat.selectedCell;
export const selectSelectedMetric = (state) => state.shapeCarat.selectedMetric;
export const selectSelectedNeedsMetric = (state) => state.shapeCarat.selectedNeedsMetric;

export default shapeCaratSlice.reducer;